"use client";
import React from 'react';
import { Button } from '@/components/admin/ui/button';

type Props = {
  count: number;
  actions: { key: string; label: string; onClick: () => void; disabled?: boolean }[];
  onClear: () => void;
};

export default function BulkBar({ count, actions, onClear }: Props) {
  if (count <= 0) return null;
  return (
    <div className="sticky top-0 z-10 border-b bg-background/90 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex items-center gap-3 p-2 text-sm">
        <span className="font-medium">{count} selected</span>
        {actions.map(a => (
          <Button key={a.key} className="text-sm" onClick={a.onClick} disabled={!!a.disabled}>{a.label}</Button>
        ))}
        <div className="ml-auto" />
        <Button className="text-sm" onClick={onClear}>Clear</Button>
      </div>
    </div>
  );
}
